import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { mobile } from 'styles/media';

const { color, radius } = theme;

const wrap: CSSObject = {
  position: 'relative',
  display: 'inline-flex',
  [mobile]: {
    flex: '1 1 auto',
  },
};

const trigger = (isOpen: boolean, isFiltered: boolean): CSSObject => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  width: '100%',
  height: 40,
  padding: '0 10px 0 12px',
  border: `1px solid ${isOpen ? color.primary : color.grey100}`,
  borderRadius: 10,
  background: isFiltered ? color.grey75 : color.white,
  fontSize: 14,
  fontWeight: isFiltered ? 600 : 500,
  color: color.text,
  whiteSpace: 'nowrap',
  transition: 'border-color 0.15s ease, background-color 0.15s ease',
  ':hover': {
    borderColor: isOpen ? color.primary : color.grey200,
  },
});

const label: CSSObject = {
  color: color.grey500,
  fontWeight: 500,
};

const arrow = (isOpen: boolean): CSSObject => ({
  marginLeft: 'auto',
  color: color.grey400,
  transform: `rotate(${isOpen ? 180 : 0}deg)`,
  transition: 'transform 0.2s ease',
});

const menu: CSSObject = {
  position: 'absolute',
  top: 'calc(100% + 6px)',
  left: 0,
  zIndex: 10,
  minWidth: '100%',
  padding: 6,
  background: color.white,
  border: `1px solid ${color.grey100}`,
  borderRadius: radius.md,
  boxShadow: theme.shadow.popover,
};

const item: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  height: 40,
  padding: '0 10px',
  borderRadius: radius.sm,
  fontSize: 14,
  color: color.text,
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  userSelect: 'none',
  ':hover': {
    background: color.grey50,
  },
  '&[aria-disabled="true"]': {
    color: color.grey300,
    cursor: 'not-allowed',
  },
};

const check = (checked: boolean): CSSObject => ({
  flex: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 20,
  height: 20,
  borderRadius: 6,
  color: checked ? color.white : 'transparent',
  background: checked ? color.primary : color.white,
  boxShadow: checked ? 'none' : `inset 0 0 0 1.5px ${color.grey200}`,
  transition: 'background-color 0.12s ease',
});

export { wrap, trigger, label, arrow, menu, item, check };
